import { Fieldset, HStack, Text, VStack } from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import { Switch } from '@components/ui/switch';
import { useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import { Organization } from '@/types/config/config.types';

export default function OrganizationAlertForm() {
  const { values, errors, touched, setFieldValue } = useFormikContext<Partial<Organization>>();

  return (
    <CockpitFormLayout title="components.organizations.alerts.title" showSeparator={false}>
      <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
        <VStack gap={5}>
          <VStack padding={4} gap={1.5} width="100%" border="2px solid" borderColor="neutral.850" alignItems="start">
            <HStack width="100%" alignItems="start">
              <Text whiteSpace="pre-line">
                <FormattedMessage id="components.organizations.alerts.utmAlerts" />
              </Text>
              <Switch
                size="sm"
                marginLeft="auto"
                checked={values.organizationParameter?.enableUtmAlerts}
                onCheckedChange={() => {
                  setFieldValue(
                    'organizationParameter.enableUtmAlerts',
                    !values.organizationParameter?.enableUtmAlerts,
                  );
                }}
              />
            </HStack>
          </VStack>
          <VStack padding={4} gap={1.5} width="100%" border="2px solid" borderColor="neutral.850" alignItems="start">
            <HStack width="100%" alignItems="start">
              <Text whiteSpace="pre-line">
                <FormattedMessage id="components.organizations.alerts.ladAlerts" />
              </Text>
              <Switch
                size="sm"
                marginLeft="auto"
                checked={values.organizationParameter?.enableLadAlerts}
                onCheckedChange={() => {
                  setFieldValue(
                    'organizationParameter.enableLadAlerts',
                    !values.organizationParameter?.enableLadAlerts,
                  );
                }}
              />
            </HStack>
          </VStack>
          <VStack padding={4} gap={1.5} width="100%" border="2px solid" borderColor="neutral.850" alignItems="start">
            <HStack width="100%" alignItems="start">
              <Text whiteSpace="pre-line">
                <FormattedMessage id="components.organizations.alerts.technicalAlerts" />
              </Text>
              <Switch
                size="sm"
                marginLeft="auto"
                checked={values.organizationParameter?.enableTechAlerts}
                onCheckedChange={() => {
                  setFieldValue(
                    'organizationParameter.enableTechAlerts',
                    !values.organizationParameter?.enableTechAlerts,
                  );
                }}
              />
            </HStack>
          </VStack>
          <VStack padding={4} gap={1.5} width="100%" border="2px solid" borderColor="neutral.850" alignItems="start">
            <HStack width="100%" alignItems="start">
              <Text whiteSpace="pre-line">
                <FormattedMessage id="components.organizations.alerts.perimAlerts" />
              </Text>
              <Switch
                size="sm"
                marginLeft="auto"
                checked={values.organizationParameter?.enablePeriAlerts}
                onCheckedChange={() => {
                  setFieldValue(
                    'organizationParameter.enablePeriAlerts',
                    !values.organizationParameter?.enablePeriAlerts,
                  );
                }}
              />
            </HStack>
          </VStack>
        </VStack>
      </Fieldset.Root>
    </CockpitFormLayout>
  );
}
